// extracted by mini-css-extract-plugin
export default {"container":"Information_container__Dd3Qm","darkmode":"Information_darkmode__0W9x1"};